import { Box, Icon, Typography } from "@bca/ui-library";
import React from "react";
import styled from "styled-components";

const NotesBox = styled(Box)`
  border-top: 1px solid whitesmoke;
  display: flex;
  flex-direction: row;
`;

interface VehicleNotesProps {
  userNote: string;
}

const VehicleNotes: React.FunctionComponent<VehicleNotesProps> = ({
  userNote,
}) => {
  return (
    <NotesBox width="auto" height="auto" padding="5px 13px 5px 15px">
      <Box
        width="auto"
        height="auto"
        display="flex"
        flexDirection="column"
        justifyContent="center"
      >
        <Icon
          name="sticky-note"
          color="footer-blue"
          width="16px"
          height="18px"
        />
      </Box>
      <Typography
        css={`
          word-break: break-word;
        `}
        ml="19px"
        variant="body-small"
        color="footer-blue"
      >
        {userNote}
      </Typography>
    </NotesBox>
  );
};

export default VehicleNotes;
